export class OrganizationCheckRegister{
    id:number;
    organizationId:number;
    rodeoId:number;
    name:string;
    memo:string;
    streetAddress:string;
    city:string;
    state:string;
    zipcode:string;
    amount:string;
    checkNumber:string;
    datePrinted:string;
    voided: boolean;

    time?: number;
    score?: number;

    constructor() {
        this.id = 0;
    }
}

export class RodeoInfo{
    rodeoId:number;
    organizationId:number;
}


// WEBPACK FOOTER //
// ./src/model/organizationCheckRegister.ts